var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pa-3"},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" Address: ")]),_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.formatted)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }